import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    events: {}
  },
  getters: {
    events(state) {
      return state.events;
    }
  },
  actions: {
    getEventsForUser({ commit, rootState }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let eventsRef = db.collection(
          `users/${rootState.user.user.uid}/lists/_events/active`
        );
        let events = [];

        eventsRef
          .get()
          .then(function(querySnapshot) {
            let docs = querySnapshot.docs;
            for (let doc of docs) {
              events[doc.id] = doc.data();
            }
            commit("SET_EVENTS", events);
            res(events);
          })
          .catch(error => {
            console.log("Error getting user documents: ", error);
          });
      });
    },
    getEventById({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guide = null;
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        listingGuideRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              guide = doc.data();
              console.log("Document data:", doc.data());
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
            res(guide);
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    }
  },
  //synchronous
  mutations: {
    SET_EVENTS(state, events) {
      if (events) {
        state.events = events;
      } else {
        state.events = [];
      }
    }
  }
};
